/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "451ab1d1a25eede5d655b619d1541ac38a7cd3cf";
